import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { B2bInvoiceService } from '../../../services/b2b-invoice.service';
import { ContractsService } from '../../../services/contracts.service';
import { ErrorService } from '../../../shared/services/error.service';

@Component({
  selector: 'app-b2b-price-table',
  templateUrl: './b2b-price-table.component.html',
  styleUrls: ['../shared/b2b-operational-shared.css']
})
export class B2bPriceTableComponent implements OnInit {
  contractId: number | null = null;
  contractNumber = '';
  contractName = '';
  companyName = '';
  customerName = '';
  form!: FormGroup;
  loading = false;
  saving = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private invoiceService: B2bInvoiceService,
    private contractsService: ContractsService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      reserveDailyAmount: [null, [Validators.min(0)]],
      telemetryMonthlyAmount: [null, [Validators.min(0)]],
      claimUseWinnerBudget: [true],
      claimFixedAmount: [null, [Validators.min(0)]],
      notes: ['']
    });

    this.route.params.subscribe(params => {
      this.contractId = +params['id'];
      if (this.contractId) {
        this.loadContractInfo();
        this.loadPriceTable();
      }
    });
  }

  loadContractInfo(): void {
    if (!this.contractId) return;
    this.contractsService.getB2bContractById(this.contractId).subscribe({
      next: (c: any) => {
        this.contractNumber = c.contractNumber || c.ContractNumber || '';
        this.contractName = c.contractName || c.ContractName || '';
        this.companyName = c.companyName || c.CompanyName || '';
        this.customerName = c.customerName || c.CustomerName || '';
      },
      error: (err) => this.errorService.handleHttpError(err)
    });
  }

  get contractDisplayName(): string {
    return this.companyName || this.customerName || this.contractName || this.contractNumber || '';
  }

  loadPriceTable(): void {
    if (!this.contractId) return;
    this.loading = true;
    this.invoiceService.getPriceTable(this.contractId).subscribe({
      next: (table) => {
        const t = table as any;
        this.form.patchValue({
          reserveDailyAmount: t.reserveDailyAmount ?? t.ReserveDailyAmount ?? null,
          telemetryMonthlyAmount: t.telemetryMonthlyAmount ?? t.TelemetryMonthlyAmount ?? null,
          claimUseWinnerBudget: t.claimUseWinnerBudget ?? t.ClaimUseWinnerBudget ?? true,
          claimFixedAmount: t.claimFixedAmount ?? t.ClaimFixedAmount ?? null,
          notes: t.notes ?? t.Notes ?? ''
        });
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.errorService.handleHttpError(err);
      }
    });
  }

  save(): void {
    if (!this.contractId || this.form.invalid) return;
    this.saving = true;
    const raw = this.form.getRawValue();
    this.invoiceService.savePriceTable(this.contractId, {
      b2BContractId: this.contractId,
      reserveDailyAmount: raw.reserveDailyAmount,
      telemetryMonthlyAmount: raw.telemetryMonthlyAmount,
      claimUseWinnerBudget: !!raw.claimUseWinnerBudget,
      claimFixedAmount: raw.claimFixedAmount,
      notes: raw.notes || null
    }).subscribe({
      next: () => {
        this.saving = false;
        this.errorService.showSuccessMessage('Tabela de preços salva.');
      },
      error: (err) => {
        this.saving = false;
        this.errorService.handleHttpError(err);
      }
    });
  }

  navigateBack(): void {
    if (this.contractId) {
      this.router.navigate(['/b2b/contracts', this.contractId, 'faturas']);
    }
  }
}
